import React from 'react'
import { Helmet } from 'react-helmet'
import { camelCase } from 'tiny-compose-fns/noFp'

import { Layout } from '../components/Layout'
import { PreviewIndicator } from '../components/PreviewIndicator'

export const GenericTemplate = ({
  children,
  data,
  customType: rawCustomType = 'page',
}) => {
  const customType = camelCase(`prismic ${rawCustomType}`)

  const metaTitle = data?.[customType]?.data?.meta_title
  const metaDescription = data?.[customType]?.data?.meta_description
  const pageTitle = data?.[customType]?.data?.title?.text

  return (
    <>
      <Helmet>
        <title>{metaTitle || pageTitle}</title>
        {metaDescription && (
          <meta name="description" content={metaDescription} />
        )}
      </Helmet>

      <Layout>
        {children}
        <PreviewIndicator />
      </Layout>
    </>
  )
}
